<template>

    <!-- Page Sidebar Ends-->
    <div class="page-body">
        <PageTitle title="Visitor List" />
        <div class="container-fluid">
            <div class="col-xxl-12">
                <div class="card">
                    
                    <div class="card-body">
                        <!--<ul class="nav nav-tabs border-tab border-0 mb-0 nav-danger" id="topline-tab" role="tablist">-->
                        <!--    <li class="nav-item"><a class="nav-link active nav-border pt-0 txt-danger nav-danger"-->
                        <!--            id="all-gatepass-tab" data-bs-toggle="tab" href="#all-gatepass" role="tab"-->
                        <!--            aria-controls="all-gatepass" aria-selected="true"><i-->
                        <!--                class="icofont icofont-man-in-glasses"></i>All</a></li> -->
                        <!--</ul>-->
                        <div class="tab-content" id="topline-tabContent">
                            <div class="tab-pane fade show active" id="all-gatepass" role="tabpanel"
                                aria-labelledby="all-gatepass-tab">
                                <div class="card-body px-0 pb-0">

                            
                                      



                                    <div class="user-content">
                                        <div v-if="isMobileView()" class="container ">
                                            
                                              <div class="form-group d-flex align-items-center pb-2 gap-2">
                                                  <input
                                                    type="text"
                                                    v-model="search_text_all"
                                                    class="form-control"
                                                    placeholder="Search..."
                                                  />  
                                                   <span
                                                        class="badge bg-primary text-white"
                                                        v-if="reschedule.length > 0"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#rescheduleHere"
                                                        style="cursor: pointer"
                                                      >
                                                        <i class="icofont icofont-ui-reply text-warning"></i> Reschedule
                                                      </span>
                                                </div>
                                                             <div
                                                        v-for="(item, index) in filterd_visitors"
                                                        :key="item.id"
                                                        class="visitor-card  mb-2 p-2  rounded-4"
                                                      >
                                                        <div class="d-flex justify-content-between align-items-start" :for="'visitor_'+ index" >
                                                          <div>
                                                            <h5 class="fw-bold text-primary mb-2">
                                                              <i class="bi bi-person-fill me-1"></i>#{{ index + 1 }} - {{ item.name }}
                                                               <input type="checkbox" :id="'visitor_'+ index" @click="() => { selectUsers(item.id) }" :value="item.id" />
                                                            </h5>
                                                            <p class="mb-1"><i class="bi bi-building me-1"></i><strong>Firm:</strong> {{ item.firmname }}</p>
                                                            <p class="mb-1"><a :href="'tel:'+item.contact "><i class="bi bi-telephone-fill me-1"></i><strong>Contact:</strong> {{ item.contact }}</a> </p>
                                                            <p class="mb-1"><i class="bi bi-geo-alt-fill me-1"></i><strong>Address:</strong> {{ item.address }}</p>
                                                            <p class="mb-1"><i class="bi bi-person-badge-fill me-1"></i><strong>Designation:</strong> {{ item.designation }}</p>
                                                          </div>
                                                    
                                                          <div>
                                                            <img
                                                              :src="item.photo ? ($hostname + 'writable/uploads/visitors/' + item.photo) : ($hostname + 'writable/visitors/user.png')"
                                                              @click="_showingUserPic(item, 1)"
                                                              class="img-thumbnail profile-img"
                                                              alt="Visitor Photo"
                                                            />
                                                          </div>
                                                        </div>
                                                    
                                                        <div class="mt-3" v-if="user.empdept == sd || user.emprole == 1">
                                                          <p class="fw-semibold mb-2"><i class="bi bi-card-heading me-1"></i>Aadhaar Card:</p>
                                                          <img
                                                            :src="item.aadharcard ? ($hostname + 'writable/uploads/aadhar_card/' + item.aadharcard) : ($hostname + 'writable/visitors/user.png')"
                                                            @click="_showingUserPic(item, 2)"
                                                            class="img-thumbnail aadhar-img"
                                                            alt="Aadhaar Card"
                                                          />
                                                        </div>
                                                    
                                                        <div class="mt-4 d-flex gap-3" v-if="user.empdept == sd || user.emprole == 1">
                                                          <button class="btn btn-sm btn-outline-danger rounded-pill px-3" @click="editlist(item.id)">
                                                            <i class="bi bi-pencil-square me-1"></i>Edit
                                                          </button>
                                                          <button class="btn btn-sm btn-outline-primary rounded-pill px-3" @click="deleteitem(item.id)">
                                                            <i class="bi bi-trash3 me-1"></i>Delete
                                                          </button>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    
                                                    
                                        <div v-else class="table-responsive custom-scrollbar">
                                            <table class="table display datatable" id="visitorlist">
                                                <thead>
                                                    <tr>
                                                  
                                                        <th>SR</th>
                                                        <th>Name</th>
                                                        <th>Firm Name</th>
                                                        <th>Contact</th>
                                                        <th>Photo</th>
                                                        <th  v-if="user.empdept == sd || user.emprole == 1">Adhaar Card</th>
                                                        <th>address</th>
                                                        <th>designation</th>
                                                        <th  v-if="user.empdept == sd || user.emprole == 1">Action</th>
                                                        <th  v-if="user.empdept == sd || user.emprole == 1">Delete</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index)  in  visitorlist" :key="visitorlist.id">
                                                        <td>{{ index+1 }}</td>       
                                                        <td>{{ item.name }} </td>
                                                        <td>{{ item.firmname }} </td>
                                                        <td>{{ item.contact }}</td>
                                                        <td><img :src="item.photo ? (this.$hostname + 'writable/uploads/visitors/' + item.photo) : (this.$hostname + 'writable/visitors/user.png')" v-if="imageUrl" @click="_showingUserPic(item,1)" style="height: 50px; width:50px;"/></td>
                                                        <td   v-if="user.empdept == sd || user.emprole == 1"><img :src="item.aadharcard ? (this.$hostname + 'writable/uploads/aadhar_card/' + item.aadharcard) : (this.$hostname + 'writable/visitors/user.png')" v-if="imageUrl" @click="_showingUserPic(item,2)" style="height: 50px; width:50px;"/></td>
                                                        <td>{{ item.address }} </td>
                                                        <td>{{ item.designation }}</td>
                                                        <td  v-if="user.empdept == sd || user.emprole == 1">
                                                            <span class="badge bg-danger" @click="editlist(item.id)">Edit</span>
                                                          </td>
                                                      
                                                          <td  v-if="user.empdept == sd || user.emprole == 1">
                                                            <span class="badge bg-primary" @click="deleteitem(item.id)" >Delete</span>
                                                          </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        

                                    </div>
                                </div>
                            </div>
                          
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>

<div class="modal fade" id="rescheduleHere" tabindex="-1" role="dialog" aria-labelledby="rescheduleHere"
        aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Create Gate Pass </h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12 position-relative">
                            <label class="form-label">Purpose</label>
                            
                            <select v-model="reschedule_data.purpose" class="form-select">
                              <option disabled selected>Select Purpose</option>
                              <option v-for="purpose in purpose_list" :key="purpose" :value="purpose">
                                {{ purpose }}
                              </option>
                            </select>
                            <!--<input class="form-control" type="text" v-model="reschedule_data.purpose"-->
                            <!--    placeholder="Type Here..." required="">-->
                        </div>
                        <div class="col-md-12 position-relative">
                            <label class="form-label">Reschedule Date</label>
                            <input class="form-control" type="date" v-model="reschedule_data.date" :min="max_today_date"
                                placeholder="Type Here..." required="">
                        </div> 
                        
                    </div>
                    <div class="table-responsive custom-scrollbar">
                       <table class="table">
                                    <tr  v-for="(already_exist_row_here, index) in already_exist" :key="index" >
                                        <td class="text-danger">
                                            {{already_exist_row_here}}
                                        </td>
                                        
                                    </tr>
                                    
                                </table>
                                </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12">
                        <div class="row">

                            <div class="col-12">
                                <button class="btn btn-sm btn-primary" @click="reschedule_pass">Generate Pass</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div v-if="showEditModal" class="modal d-block" tabindex="-1" role="dialog" style="background: rgba(0,0,0,0.5);">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Visitor</h5>
              <button type="button" class="close" @click="showEditModal = false" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
      
            <div class="modal-body">
              <div class="form-group">

                <input type="hidden" v-model="editvisitorlist.id" />
                
                <div class="col-12 row">
                    
                 <div class="col-6">
                <label>Name</label>
                <input type="text" v-model="editvisitorlist.name" class="form-control" />
              </div>
              

              <div class="col-6">

              <div class="form-group">
                <label>Firm Name</label>
                <input type="text" v-model="editvisitorlist.firmname" class="form-control" />
              </div>

              </div>

              </div>
              </div>



              <div class="col-12 row">
                <div class="col-6">
              <div class="form-group">
                <label>Contact</label>
                <input type="text" v-model="editvisitorlist.contact" class="form-control" />
              </div>
              </div>


              <div class="col-6">
              <div class="form-group">
                <label>Designation</label>
                <input type="text" v-model="editvisitorlist.designation" class="form-control" />
              </div>

              </div>
              </div>




           <div class="col-12 row">
                <div class="col-6">  
                        <label>User Photo</label> <br>
                         <label for="user_profile_pic">
                        
                        <img :src="imageUrls?imageUrls:this.$hostname+'writable/uploads/visitors/'+(editvisitorlist.photo?editvisitorlist.photo:'user.png')" alt="Uploaded Image" style="height: 80px;width: 80x; " />
                        <input type="file" style="display:none" id="user_profile_pic" @change="handlePhotoUpload" class="form-control-file" />
                        </label>
                    </div>  
                <div class="col-6">  
                        <label>Adhar Photo</label> <br>
                         <label for="user_adhar_pic">
                        
                        <img :src="imageUrls_aadharcard?imageUrls_aadharcard:this.$hostname+'writable/uploads/aadhar_card/'+(editvisitorlist.aadharcard?editvisitorlist.aadharcard:'user.png')"  alt="Uploaded Image" style="height: 80px;width: 80x; " />
                        <input type="file" style="display:none" id="user_adhar_pic" @change="handleAdharUpload" class="form-control-file" />
                        </label>
                    </div>  


              </div>





    
           
              <div class="form-group mt-2">
                <label>Address</label>
                <textarea v-model="editvisitorlist.address" class="form-control"></textarea>
              </div>
             
          
              
            
            
       


            </div>
      
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" @click="updatevisitor">Save changes</button>
            </div>
          </div>
        </div>
      </div>
  


<!-- photo show modal -->



<div class="modal fade" id="showingUserPic" tabindex="-1" role="dialog" aria-labelledby=" "
aria-hidden="true">
<div class="modal-dialog" role="document">
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title">User Image</h4>
            <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
            <div class="modal-toggle-wrapper ">
                <div class="col-sm-12">
                      <img alt="" :src="getImageUrlV1(showingUserPic.photo)"
                                                            class="img img-thumbnail" :alt="showingUserPic.name">
                </div>
            </div> 
        </div>
        <!--<div class="modal-footer">-->
        <!--    <div class="col-12">-->
        <!--        <button class="btn btn-primary" @click=""> </button>-->
        <!--    </div>-->
        <!--</div>-->
    </div>
</div>
</div>






<div class="modal fade" id="showingUseradhaar" tabindex="-1" role="dialog" aria-labelledby=" "
aria-hidden="true">
<div class="modal-dialog" role="document">
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title">Adhaar Image</h4>
            <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
            <div class="modal-toggle-wrapper ">
                <div class="col-sm-12">
                      <img alt="" :src="getImageUrlV2(ids.aadharcard)"
                                                            class="img img-thumbnail" :alt="ids.name">
                </div>
            </div> 
        </div>
        <!--<div class="modal-footer">-->
        <!--    <div class="col-12">-->
        <!--        <button class="btn btn-primary" @click=""> </button>-->
        <!--    </div>-->
        <!--</div>-->
    </div>
</div>
</div>






 <!-- photo show modal -->














</template>
<style scoped>
.avatar {
    width: 50px;
    height: 50px;
    border-radius: 30px;
}

.badge_sm {
    padding: 2px 5px;
    border-radius: 10px;
    font-size: smaller;
    color: white;
}
.visitor-card {
  background-color: #ffffff;
  transition: all 0.3s ease-in-out;
  border: 1px solid #002284;
  box-shadow: 1px 1px 5px gray;
}

.visitor-card:hover {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  transform: translateY(-4px);
}

.profile-img,
.aadhar-img {
  height: 70px;
  width: 70px;
  object-fit: cover;
  border-radius: 0.75rem;
  cursor: pointer;
  transition: transform 0.2s;
}

.profile-img:hover,
.aadhar-img:hover {
  transform: scale(1.05);
}
</style>
<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue';
import ModalsPart from '@/components/Modals.vue';
import GatePass from '@/components/GatepassPrint.vue';
import Swal from 'sweetalert2';
// import axios from 'axios';
import axios from "@/plugins/axios";
import QRCode from 'qrcode';

export default {
    name: 'CreateGatepass',
    components: {
        PageTitle, ModalsPart, GatePass
    }, mounted() {
        this.getBasics();
        

    }, data() {
       
        return {
            imageUrl: this.$hostname,//"https://vms.dktsoft.in/backend/writable/editvisitorlist.photo",
            reschedule: [],
            user: [],
            editvisitorlist: {
            id:'',
            name: '',
            firmname: '',
            contact: '',
            photos: '',
            address: '',
            designation: '',
            authtoken:'',
            },
            imageUrls: null, 
            imageUrls_aadharcard:null,

            visitorlist:[],
            
            showEditModal: false,
            sd:0,
            showingUserPic:{
                photo:'',
                name:'',
                
            },
            ids: {
                name: '',
                aadharcard: ''
                },
            search_text_all:'',
            reschedule_data: { 'date': this.todayDate(), 'purpose': '', 'time': '' },
            filterd_visitors:[],
            already_exist:[],
            max_today_date:this.todayDate(),
            purpose_list:[]//30.05.2025
          
      

        }
    }, 
    watch:{
         search_text_all(newVal) {
              this.onSearchTypeAll(newVal); 
         },
    },
    methods: {
            todayDate() {
                var today = new Date();
                var month = today.getMonth() + 1;

                return today.getFullYear() + '-' + ((month < 10) ? '0' + month : month) + '-' + ((today.getDate() < 10) ? '0' + today.getDate() : today.getDate());//today.getDate();;

            },

           selectUsers(id) {
        //   console.log(id);
            if (this.reschedule.includes(id)) {
                this.reschedule.pop(id)
            } else {
                this.reschedule.push(id)
            }
            console.log(this.reschedule);
        },
         reschedule_pass(item) {
            var self=this;
            if(self.reschedule_data.purpose=='')
                {
                     self.$swal("Please Mention Purpose");
                     return;
                }else if(!self.reschedule_data.date)
                {
                     self.$swal("Please Mention Date");
                     return;
                }else
            if(this.reschedule.length>0){
                axios.post('re_createGatePass', { reschedule: this.reschedule,reschedule_data: this.reschedule_data }).then(function (response) {
                        if(response.data.already_exist && response.data.already_exist.length>0)
                                self.already_exist=response.data.already_exist;
                        else if (response.data.gatepass_success == 1) {
                                $("#rescheduleHere").modal("toggle");
                                self.reschedule_data= { 'date': self.todayDate(), 'purpose': '', 'time': '' };
                        }
                        
                        self.$swal(response.data.gatepass_statusmsg);
                        
                        
                          }).then(() => {
                                


                            });
            }
        },
            
            
         onSearchTypeAll(query) {
                if(query){
                        this.filterd_visitors = this.visitorlist.filter(item =>
                          item.name.toLowerCase().includes(query.toLowerCase())||
                          item.firmname.toLowerCase().includes(query.toLowerCase())||
                          item.contact.toLowerCase().includes(query.toLowerCase())||
                          item.address.toLowerCase().includes(query.toLowerCase())
                        );
                        }else{
                                          this.filterd_visitors = this.visitorlist;
                                     }
              },
         isMobileView() {
            //  return true;
              if (window.innerWidth <= 768) {
                //   alert("Yes");
                return true;
                } else {
                    // alert("No");
                  return false;
                }
              },
        getBasics() {
            var self = this;
            axios.post('getvisitorlist').then(function (response) {
                
                self.visitorlist = response.data.visitorlist;
                self.purpose_list = response.data.purpose_list;
                self.filterd_visitors=self.visitorlist;
                self.user = response.data.user;
                self.sd = response.data.sd;
                window.scrollTo(0, 0);
            }).then(() => {
               self.dataTable= $(".datatable").DataTable({
                    dom: 'Bfrtip',
                    buttons: ['excel', 'pdf'],
                    "paging": true,
                    "ordering": true,
                    "autoWidth": false
                });
            });


        },
          dataURLtoBlob(dataURL) {
                const byteString = atob(dataURL.split(',')[1]);
                const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
                const ab = new ArrayBuffer(byteString.length);
                const ia = new Uint8Array(ab);
                for (let i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }
                return new Blob([ab], { type: mimeString });
            },

    handlePhotoUpload(event) {
        const file = event.target.files[0]; // Get the file selected by the user
        if (file) {
            this.editvisitorlist.photos = file;  
            this.imageUrls = URL.createObjectURL(file);
        }
    },
         handleAdharUpload(event) {
        const file = event.target.files[0]; // Get the file selected by the user
        if (file) {
            this.editvisitorlist.aadharcard = file; // Store the file in editvisitorlist
            // Create a temporary URL for the image file for preview
            this.imageUrls_aadharcard = URL.createObjectURL(file);
        }
    },


        deleteitem(id) {
        var self = this;
        Swal.fire({
            title: 'Are you sure?',
            text: "Do you really want to delete this?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
        if (result.isConfirmed) {
            axios.post('deletevisitorlist', { id: id }).then(function (response) {
                self.visitorlist = response.data.visitorlist;
                self.message = response.data.message;
                
                self.$swal(self.message);

                window.scrollTo(0, 0);
              
            });
        }
    });
},


        editlist(id) {

            var self = this;
            axios.post('editvisitorlist', { id: id }).then((response) => {
               
                self.editvisitorlist = response.data.visitorlist;

                self.showEditModal = true;
                self.imageUrls_aadharcard=null;
                self.imageUrls=null;
              

                window.scrollTo(0, 0);

            }).catch((error) => {
                console.error('Error editing item:', error);
            });
        },




        destroyTable(){
                if ($.fn.dataTable.isDataTable('#visitorlist')) {
                                    $('#visitorlist').DataTable().destroy();
                                }
                            },

            refreshTable(){
                    $("#visitorlist").DataTable({
                        dom: 'Bfrtip',
                        buttons: ['excel', 'pdf'],
                        "paging": true,
                        "ordering": true,
                        "autoWidth": false
                    });
                },




          updatevisitor() {
                  const self = this;
                  const formData = new FormData();
                
                  // Append only actual files
                  if (self.editvisitorlist.photos instanceof File) {
                    formData.append('photos', self.editvisitorlist.photos);
                  }
                  if (self.editvisitorlist.aadharcard instanceof File) {
                    formData.append('aadharcard', self.editvisitorlist.aadharcard);
                  }
                
                  // Append other data fields (excluding the File objects)
                  for (const key in self.editvisitorlist) {
                    if (
                      key !== 'photos' &&
                      key !== 'aadharcard' &&
                      Object.prototype.hasOwnProperty.call(self.editvisitorlist, key)
                    ) {
                      formData.append(key, self.editvisitorlist[key]);
                    }
                  }
                
                  axios.post('updatevisitor', formData, {
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    }
                  })
                  .then(function (response) {
                    self.destroyTable();
                    if (response.data.status == 1) {
                      self.visitorlist = response.data.visitorlist;
                      self.status = response.data.status;
                      self.message = response.data.message;
                      self.showEditModal = false;
                    }
                    self.$swal(self.message);
                    window.scrollTo(0, 0);
                  })
                  .then(() => {
                    self.refreshTable();
                  });
                },
            _showingUserPic(gatepass_row,id) {
                if(id==1){
                    this.showingUserPic.name = gatepass_row.name;
                    this.showingUserPic.photo = gatepass_row.photo ;
                    $("#showingUserPic").modal("toggle");
                }
                else if(id==2){
                    this.ids.name = gatepass_row.name;
                    this.ids.aadharcard = gatepass_row.aadharcard ;
                    $("#showingUseradhaar").modal("toggle");

                }
                   
        },

        getImageUrlV1(image) {
            //return `${this.$hostname}/writable/uploads/visitors/${image}`;
            if(image && !image.includes('.bin'))
                return `${this.$hostname}writable/uploads/visitors/${image}`;
          
            else
                return `${this.$hostname}writable/visitors/user.png`;
        },
        getImageUrlV2(adhaar_card) {
          //  alert(adhaar_card)
            //return `${this.$hostname}/writable/uploads/visitors/${image}`;
            if(adhaar_card && !adhaar_card.includes('.bin'))
                return `${this.$hostname}writable/uploads/aadhar_card/${adhaar_card}`;
           
            else
                return `${this.$hostname}writable/visitors/user.png`;
        },





     
          
    }
}
</script>

<style>
    .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}
.modal-wrapper {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    width: 400px;
}

    </style>
